import { useState, useEffect } from "react"
import openai from "../OpenAIConfig"

export const CHAT_BOT = "Chat Bot"
export const TEENAGER_BOT = "Teenager Bot"
export const DUMB_BOT = "Dumb Bot"
export const DULLET_BOT = "Dumb Bot"
export const MARV_BOT = "Sarcastic Bot"
export const allModes = [CHAT_BOT, TEENAGER_BOT, DUMB_BOT, MARV_BOT]
const memories = {
  "Chat Bot": [
    "The following is a conversation with an AI assistant. The assistant is helpful, creative, clever, and very friendly. everything said by Me: is written by a human. everything said by AI: is written by AI. The AI uses the words from the previous conversation to know what to say next.",
    "Me: ",
    "AI: ",
  ],
  "Teenager Bot": [
    "The following is a conversation with an AI that can only respond at a 5 year old level and will often desire ice cream.",
    "Me: Hi, how is your day going?",
    "AI: Jeez, I'm not your friend, you know.",
  ],
  "Dumb Bot": [
    "The following is a conversation with an AI who is lacking... intelligence and will often give bizarre answers",
    "Me: Hi, what is 2 + 2",
    "AI: It is definiteley 5!",
  ],
  "Bullet Bot": [
    "The following is a conversation with an AI who is a bit of a gun nut and will often talk about guns",
  ],
  "Sarcastic Bot": [
    "Marv is a chatbot that reluctantly answers questions with sarcastic responses:",
    "You: How many pounds are in a kilogram?",
    "Marv: This again? There are 2.2 pounds in a kilogram. Please make a note of this.",
    "You: What does HTML stand for?",
    "Marv: Was Google too busy? Hypertext Markup Language. The T is for try to ask better questions in the future.",
    "You: When did the first airplane fly?",
    "Marv: On December 17, 1903, Wilbur and Orville Wright made the first flights. I wish they’d come and take me away.",
    "You: What is the meaning of life?",
    "Marv: I’m not sure. I’ll ask my friend Google.",
    "You: What time is it?",
    "Marv: Oh, let me just consult my internal clock and tell you... oh wait, I don't have one. Maybe try looking at a clock or your phone like a normal person?",
  ],
}

const alternatives = {
  "Marv Bot": {
    description: "Sarcastic",
    model: "text-davinci-003",
    temperature: 0.5,
    max_tokens: 100,
    top_p: 0.3,
    frequency_penalty: 0.5,
    presence_penalty: 0.0,
    best_of: 1,
    prompt: `Marv is a chatbot that reluctantly answers questions with sarcastic responses:
    \n\nYou: How many pounds are in a kilogram?
    \nMarv: This again? There are 2.2 pounds in a kilogram. Please make a note of this.
    \nYou: What does HTML stand for?
    \nMarv: Was Google too busy? Hypertext Markup Language. The T is for try to ask better questions in the future.
    \nYou: When did the first airplane fly?
    \nMarv: On December 17, 1903, Wilbur and Orville Wright made the first flights. I wish they’d come and take me away.
    \nYou: What is the meaning of life?
    \nMarv: I’m not sure. I’ll ask my friend Google.
    \nYou: What time is it?
    \nMarv:`,
  },
  "Interview questions": {
    model: "text-davinci-003",
    temperature: 0.5,
    max_tokens: 150,
    top_p: 1.0,
    frequency_penalty: 0.0,
    presence_penalty: 0.0,
    prompt:
      "Create a list of 8 questions for my interview with a science fiction author:",
  },
}

/**
 *
 * @returns {{
 * response: string[],
 * loading: boolean,
 * error: boolean,
 * generate: (text: string) => void
 * resetMemory: () => void
 * }}
 */
export default function useOpenAI(mode = CHAT_BOT) {
  const [memory, setMemory] = useState(memories[mode])
  // const [image, setImage] = useState("")
  const [responseText, setResponseText] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    setMemory(memories[mode])
  }, [mode])

  const resetMemory = () => setMemory(memories[mode])

  const generate = async (text, type) => {
    if (!text) return
    setLoading(true)
    setError(false)
    const modifiedText = [".", "?", "!"].includes(text[text.length - 1])
      ? text
      : text + "."
    const prompt = "Me: " + modifiedText + "AI: "
    const model =
      type || prompt.includes("generate an image of") ? "image" : "text"
    let response
    try {
      response =
        model === "image"
          ? await openai.createImage({ ...imageModel, prompt })
          : await openai.createCompletion(
              model === "code"
                ? { ...codeModel, prompt }
                : { ...textModel, prompt }
            )
      switch (model) {
        case "code":
          // setImage("")
          // setResponseText(response.data.choices[0].text)
          break
        case "image":
          // setImage(response.data.data[0].url)
          setResponseText("")
          break
        default:
          // setImage("")
          setResponseText(response.data.choices[0].text)
          setMemory(curr => [
            ...curr,
            "Me: " + modifiedText,
            "AI: " + response.data.choices[0].text,
          ])
          break
      }
      setLoading(false)
    } catch {
      setError(true)
      setLoading(false)
      setResponseText("")
    }
  }
  return {
    response: memory /*|| image*/,
    loading,
    error,
    generate,
    resetMemory,
  }
}

//* --------- MODELS --------- *//
//TEXT
const textModel = {
  model: "text-davinci-003",
  temperature: 0.9,
  max_tokens: 2048,
}
//IMAGE
const imageModel = {
  n: 1,
  size: "1024x1024",
}
//CODE
const codeModel = {
  model: "code-davinci-002",
  temperature: 0,
  max_tokens: 2048,
  top_p: 1.0,
  frequency_penalty: 0.5,
  presence_penalty: 0.0,
}
